module.exports = __webpack_public_path__ + "assets/img/s5-tab-2-active-1a5d84a0.png";